import { remoteJSON } from './remote';

export const getLinkGroups = async () => {
	// using this api to get server time
	const response = (await remoteJSON('/link_groups', undefined, [
		'server-time-utc',
		'server-timezone',
	])) as GetLinkGroupResponse & {
		__headers: { 'server-time-utc': string | null; 'server-timezone': string | null };
	};

	const linkGroups = response.data ?? [];

	linkGroups.sort((a, b) => a.order - b.order);

	linkGroups.forEach((linkGroup) => {
		linkGroup.links.sort((a, b) => a.order - b.order);
	});

	return {
		linkGroups,
		serverTime: response.__headers['server-time-utc'],
		serverTimezone: response.__headers['server-timezone'],
	};
};
